import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import Chat from '../components/modules/views/contableAgent/Chat/Chat'
import Conversations from '../components/modules/views/contableAgent/Conversations/Conversations'
import Layout from '../components/layouts/index'
import { useTryLucaChat } from '../components/modules/views/contableAgent/context/TryLucaChatContext'

function ContableAgentContent() {
  const [searchParams, setSearchParams] = useSearchParams()
  const {
    conversations,
    loadingConversations,
    selectConversation,
    setConversations
  } = useTryLucaChat()
  const tabParam = searchParams.get('tab')
  const activeTab = ['chat', 'history', 'favorites'].includes(tabParam) ? tabParam : 'chat'
  const favoritesConversations = useMemo(
    () => conversations.filter(conversation => conversation.isFavorite),
    [conversations]
  )

  const setActiveTab = tab => {
    setSearchParams({ tab }, { replace: true })
  }

  const tabButtonClasses = tab =>
    `relative shrink-0 border-b-2 px-2 py-2 text-sm font-medium transition-colors sm:text-base ${
      activeTab === tab
        ? 'border-accent-secondary font-semibold text-text'
        : 'border-transparent text-muted hover:text-text'
    }`

  const handleSelectConversation = conversation => {
    setActiveTab('chat')
    selectConversation(conversation)
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'chat':
        return (
          <Chat />
        )
      case 'history':
        return (
          <Conversations
            conversations={conversations}
            title='Historial de Chats'
            handleSelectConversation={handleSelectConversation}
            setConversations={setConversations}
            loading={loadingConversations}
          />
        )
      case 'favorites':
        return (
          <Conversations
            conversations={favoritesConversations}
            title='Destacados'
            handleSelectConversation={handleSelectConversation}
            setConversations={setConversations}
            loading={loadingConversations}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="flex h-[calc(100dvh-5rem)] min-h-0 flex-col px-2 pb-2 pt-3 sm:p-4">
      <div className="flex gap-1 overflow-x-auto border-b-2 border-gray text-base no-scrollbar">
        <button
          type='button'
          className={tabButtonClasses('chat')}
          onClick={() => setActiveTab('chat')}
        >
          Chat Principal
        </button>
        <button
          type='button'
          className={tabButtonClasses('history')}
          onClick={() => setActiveTab('history')}
        >
          Historial de Chats
        </button>
        <button
          type='button'
          className={tabButtonClasses('favorites')}
          onClick={() => setActiveTab('favorites')}
        >
          Destacados
        </button>
      </div>
      <div className="mt-3 min-h-0 flex-grow overflow-hidden sm:mt-4">
        {renderContent()}
      </div>
    </div>
  )
}

export default function ContableAgent() {
  return (
    <Layout>
      <ContableAgentContent />
    </Layout>
  )
}
